// Calendar boundaries are calculated in the browser's timezone, then sent as
// instants. A day can be 23, 24 or 25 hours.
export function dayBoundary(day, next = false) {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(y, m - 1, d + (next ? 1 : 0)).toISOString();
}

export function scanTableQuery({ columnFilters, search, sort }, now = new Date()) {
  const filters = Object.entries(columnFilters).filter(([, f]) => f).map(([column, f]) => {
    const out = { column, not: !!f.not };
    if (f.condition !== undefined) {
      const operators = { '=': '=', '>': '>', '<': '<', 'IS NULL': 'is_null' };
      return { ...out, operator: f.condition === 'LIKE'
        ? ({ begins: 'begins_with', ends: 'ends_with' }[f.likeMode] || 'contains')
        : operators[f.condition], value: f.value || '' };
    }
    if (f.values) return { ...out, operator: 'in', value: f.values };
    if (['today', 'last_7d', 'last_30d', 'last_90d', 'before', 'after', 'custom'].includes(f.op)) {
      let value = null, value2 = null;
      if (f.op === 'today') {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        value = start.toISOString();
        value2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).toISOString();
      } else if (f.op.startsWith('last_')) {
        value = new Date(now.getTime() - Number(f.op.match(/\d+/)[0]) * 86400000).toISOString();
        value2 = new Date(now.getTime() + 1).toISOString();
      } else if (f.op === 'before') value2 = dayBoundary(f.value);
      else if (f.op === 'after') value = dayBoundary(f.value, true);
      else {
        value = f.value ? dayBoundary(f.value) : null;
        value2 = f.value2 ? dayBoundary(f.value2, true) : null;
      }
      return { ...out, operator: 'range', value, value2 };
    }
    return { ...out, operator: ({ eq: '=', gt: '>', lt: '<', between: 'range',
      is_empty: 'is_null', not_empty: 'is_null', contains: 'contains', equals: '=',
      starts_with: 'begins_with', ends_with: 'ends_with' })[f.op],
      not: f.op === 'not_empty' || out.not, value: f.value, value2: f.value2 };
  });
  const orderedFilter = Object.entries(columnFilters).find(([, f]) => f?.order);
  const order = orderedFilter ? { col: orderedFilter[0], dir: orderedFilter[1].order } : sort;
  return { filters: JSON.stringify(filters), q: search || undefined,
    sort_by: order?.col || 'created_at', sort_dir: order?.dir || 'desc' };
}
